// Live Countdown Timer for Early Bird Discounts
class CountdownTimer {
  constructor(elementId) {
    this.element = document.getElementById(elementId);
    if (!this.element) return;

    this.endDate = new Date(this.element.dataset.endDate + 'T23:59:59');
    this.daysSpan = this.element.querySelector('.countdown-days');
    this.hoursSpan = this.element.querySelector('.countdown-hours');
    this.minutesSpan = this.element.querySelector('.countdown-minutes');
    this.secondsSpan = this.element.querySelector('.countdown-seconds');

    this.start();
  }

  start() {
    this.updateCountdown();
    // Update every second when seconds are displayed, otherwise every minute
    const updateInterval = this.secondsSpan ? 1000 : 60000;
    this.interval = setInterval(() => {
      this.updateCountdown();
    }, updateInterval);
  }

  updateCountdown() {
    const now = new Date();
    const timeLeft = this.endDate - now;

    if (timeLeft <= 0) {
      this.onExpired();
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Add breathing animation to numbers
    this.daysSpan.classList.add('countdown-number');
    this.hoursSpan.classList.add('countdown-number');
    this.minutesSpan.classList.add('countdown-number');
    if (this.secondsSpan) {
      this.secondsSpan.classList.add('countdown-number');
    }

    // German formatting with proper singular/plural
    this.daysSpan.textContent = days;
    this.hoursSpan.textContent = hours.toString().padStart(2, '0');
    this.minutesSpan.textContent = minutes.toString().padStart(2, '0');
    if (this.secondsSpan) {
      this.secondsSpan.textContent = seconds.toString().padStart(2, '0');
    }

    // Update the text content after the spans for German format
    this.updateGermanLabels(days, hours, minutes);

    // Add attention-grabbing effects based on urgency
    if (days === 0 && hours < 6) {
      this.element.classList.add('countdown-urgent');
      this.addShimmerEffect();
      this.addUrgencyPulse();
    } else if (days <= 1) {
      this.element.classList.add('countdown-warning');
      this.addUrgencyPulse();
    }
  }

  updateGermanLabels(days, hours, minutes) {
    // Update days label (Tag/Tage)
    const daysLabel = this.daysSpan.nextSibling;
    if (daysLabel && daysLabel.nodeType === Node.TEXT_NODE) {
      daysLabel.textContent = days === 1 ? ' Tag ' : ' Tage ';
    }

    // Hours stay as 'h' (short form)
    // Minutes stay as 'min' (short form)
  }

  addShimmerEffect() {
    // Add shimmer effect to the countdown numbers
    if (this.daysSpan && !this.daysSpan.classList.contains('countdown-shimmer')) {
      this.daysSpan.classList.add('countdown-shimmer');
      this.hoursSpan.classList.add('countdown-shimmer');
      this.minutesSpan.classList.add('countdown-shimmer');
      if (this.secondsSpan) {
        this.secondsSpan.classList.add('countdown-shimmer');
      }
    }
  }

  addUrgentStyling() {
    // This method is kept for backward compatibility but animations are now in CSS
    this.element.classList.add('countdown-urgent');
  }

  addUrgencyPulse() {
    // Add pulsing effect to the icon for urgency
    const fireIcon = this.element.querySelector('.animated-fire');
    const clockIcon = this.element.querySelector('.animated-clock');

    if (fireIcon) {
      fireIcon.classList.add('urgency-pulse');
    }
    if (clockIcon) {
      clockIcon.classList.add('urgency-pulse');
    }

    // Also add urgency to the parent banner
    const parentBanner = this.element.closest('.countdown-banner');
    if (parentBanner) {
      if (this.element.classList.contains('countdown-urgent')) {
        parentBanner.classList.add('countdown-urgent');
      } else if (this.element.classList.contains('countdown-warning')) {
        parentBanner.classList.add('countdown-warning');
      }
    }
  }

  onExpired() {
    clearInterval(this.interval);
    this.element.innerHTML = '<span class="text-danger fw-bold">ABGELAUFEN!</span>';

    // Optionally reload the page to update discount availability
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  }

  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

// Initialize countdown timers on turbo:load (works with Turbo/Hotwire navigation)
document.addEventListener('turbo:load', function() {
  // Initialize Super Early Bird countdown (form)
  if (document.getElementById('super-early-countdown')) {
    new CountdownTimer('super-early-countdown');
  }

  // Initialize Early Bird countdown (form)
  if (document.getElementById('early-bird-countdown')) {
    new CountdownTimer('early-bird-countdown');
  }

  // Initialize Super Early Bird countdown (sidebar)
  if (document.getElementById('sidebar-super-early-countdown')) {
    new CountdownTimer('sidebar-super-early-countdown');
  }

  // Initialize Early Bird countdown (sidebar)
  if (document.getElementById('sidebar-early-bird-countdown')) {
    new CountdownTimer('sidebar-early-bird-countdown');
  }

  // Initialize Enhanced Super Early Bird countdown
  if (document.getElementById('enhanced-super-early-countdown')) {
    new CountdownTimer('enhanced-super-early-countdown');
  }

  // Initialize Enhanced Early Bird countdown
  if (document.getElementById('enhanced-early-bird-countdown')) {
    new CountdownTimer('enhanced-early-bird-countdown');
  }
});

// Export for module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CountdownTimer;
}
